var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6:133)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.11074 3.14551C8.32039 1.53169 6.66709 0.464733 4.8126 0.464733C2.15903 0.464733 0.000210718 2.6113 0.000210718 5.24978C0.000210718 5.96682 0.154152 6.65409 0.457989 7.29488L0.00816756 9.54426C-0.0490889 9.8306 0.203507 10.0837 0.489898 10.027L2.76701 9.57682C3.0736 9.72226 3.39078 9.83287 3.71669 9.90907C2.98616 6.44905 5.6088 3.20123 9.11074 3.14551V3.14551Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5421 10.7948C13.6207 10.6291 13.689 10.4602 13.7475 10.2886H13.7325C14.7564 7.28308 12.6031 4.1243 9.42411 3.97049C9.42406 3.97033 9.42403 3.97016 9.42397 3.97C6.68868 3.84395 4.41614 6.03402 4.41614 8.74968C4.41614 11.3859 6.55877 13.5308 9.19415 13.5346C9.90899 13.5337 10.5941 13.3798 11.2331 13.0767C13.727 13.5698 13.5325 13.5347 13.5898 13.5347C13.8489 13.5347 14.0426 13.2972 13.9919 13.0442L13.5421 10.7948Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6:133"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.fcbdcb6b5de5e6ebb472291e25c84105.svg";
export { ForwardRef as ReactComponent };